export default "__VITE_ASSET__B_6842R1__"